import React from "react";
import {NavLink} from "react-router";
import {faCog, faFileLines, faGlobe, faKey} from "@awesome.me/kit-92187fb46c/icons/classic/regular";
import {PAGES_PATHS} from "../Entrypoint";
import {useTranslation} from "react-i18next";

const {FontAwesomeIcon} = await import("@fortawesome/react-fontawesome");

export default function AdminSidebar() {
	const {t} = useTranslation();

	const menuItems = [
		{path: PAGES_PATHS.ADMIN.GLOBAL_SETTINGS, label: t("globalSettings_globalSettings"), icon: faGlobe},
		{path: PAGES_PATHS.ADMIN.TENANT_SETTINGS, label: t("tenantSettings_tenantSettings"), icon: faCog},
		{path: PAGES_PATHS.ADMIN.API_KEYS, label: t("apiKeys_apiKeys", {count: 3}), icon: faKey},
		{path: PAGES_PATHS.ADMIN.EVENTS, label: t("eventLogs_eventLogs"), icon: faFileLines},
	];

	return (
			<div id="admin-sidebar">
				{menuItems.map((item) => (
						<NavLink
								key={item.path}
								to={item.path}
								replace
								className={({isActive}) =>
										`admin-navigation-button ${isActive ? "active" : ""}`
								}
						>
							<FontAwesomeIcon icon={item.icon}/> {item.label}
						</NavLink>
				))}
			</div>
	);
}